import Swiper, { Pagination } from 'swiper';

type CarouselType = {
    items: { $carousel: HTMLElement, swiper?: Swiper }[],
    init(): void,
};

const Carousel: CarouselType = {
    items: [],

    init() : void {
        const $carousels = document.querySelectorAll<HTMLElement>('.swiper-container');

        $carousels.forEach($carousel => {
            this.items.push({ $carousel });
        });
        
        this.items.forEach(item => {
            const $slides = item.$carousel.querySelectorAll('.swiper-slide');

            const swiperArgs = {
                loop: $slides.length > 1,
                pagination: $slides.length > 1 ? {
                    el: '.swiper-pagination',
                    clickable: true,
                } : false,
                slidesPerView: 1,
                allowTouchMove: $slides.length > 1,
                threshold: 10,
                autoplay: {
                    delay: 10000,
                },
                modules: [Pagination],
            };

            item.swiper = new Swiper(item.$carousel, swiperArgs);
        });
    },
};

export default Carousel;
